import { rei } from "@/services/api"

class ValidateDeclarationService {
  static validateDnv (numeroDeclaracao, registroId = null, dataNascimento = null) {
    return rei.get(`validar-dnv`, { params: { numeroDeclaracao, registroId, dataNascimento } }).then(res => res.data)
  }

  static validateDo (numeroDeclaracao) {
    return rei.get(`validar-do`, { params: { numeroDeclaracao } }).then(res => res.data)
  }
}

export default ValidateDeclarationService
